import dynamic from 'next/dynamic'

import useAuthStore, { getAuthUser } from 'app/store/auth.store'

const TrackTimer = dynamic(() => import('./TrackTimer'), {
  ssr: false
})

const TrackUserIdle = () => {
  const user = useAuthStore(getAuthUser)

  if (!user?.id) return null

  return <TrackTimer userExp={user.exp} />
}

export default TrackUserIdle
